import { useQuery } from "@apollo/client";
import { ProfileSkeleton } from "@/components/Skeleton";
import {
  FACILITY_DETAILS_HEADER_QUERY,
  FacilityDetailsHeaderQueryResponse
} from "@/pages/facilities/[facilityId]/queries";
import ObjectHeading from "@/components/ObjectHeading";

export interface MobileFacilityOverviewProps {
  facilityId: string;
}

export default function MobileFacilityOverview({ facilityId }: MobileFacilityOverviewProps) {
  const { data, loading, error } = useQuery<FacilityDetailsHeaderQueryResponse>(FACILITY_DETAILS_HEADER_QUERY, {
    variables: { facilityId }
  });

  if (loading) return <ProfileSkeleton />;
  if (error) return <div>Error loading facility details</div>;
  if (!data?.facility) return <div>Facility not found</div>;

  const { facility } = data;

  return (
    <div className="bg-white pb-4 border-b border-sys-brand-outline-variant" data-testid="mobile-facility-overview">
      <ObjectHeading
        title={facility.name}
        iconName="location_on"
        variant="landing-page"
        metaData={[
          ...(facility.section?.name ? [{ text: facility.section.name, label: "Section" }] : []),
          ...(facility.legacyId ? [{ text: facility.legacyId, label: "Facility ID", copyable: true }] : [])
        ]}
      />
    </div>
  );
}
